import * as React from "react";

function SvgStopAll(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path d="M .833 .833 h 10 v 28.334 H .833 V .833 z" fill="#fff" />
      <path d="M 18.334 .833 h 10 v 28.334 H 18.334 V .833 z" fill="#fff" />
    </svg>
  );
}

export default SvgStopAll;
